import PaymentMPService from "../office/paymentMPService";
import PaymentSIROService from "../office/paymentSIROService";
import { FRONT_URL, FRONT_ENV } from "@/env";

const ENV = (FRONT_ENV === "PRODUCTION")

class PaymentHandlers {
  static async handleInfractionPaymentSIRO(infraction) {
    const body = {
      amount: `${infraction.cost}`,
      concept: "Pago de Multas",
      url_OK: ENV ?  `${FRONT_URL}/pago/multas` : 'https://www.google.com.ar/',
      url_NOK: ENV ?  `${FRONT_URL}/pago/multas` : 'https://www.youtube.com/',
    };

    const response = await PaymentSIROService.generatePayment(body);

    if (response.success) {
      const redirectUrl = response.data?.Url;

      if (redirectUrl) {
        window.location.assign(redirectUrl);
        return { success: false, notCut: true };
      }
      return { success: false };
    }
  }

  static async handleProcedurePaymentSIRO(procedure) {
    const body = {
      procedure_history_id: procedure.id,
      url_OK: ENV ?  `${FRONT_URL}/pago-resultado` : 'https://www.google.com.ar/',
      url_NOK: ENV ?  `${FRONT_URL}/pago-resultado` : 'https://www.youtube.com/',
    };

    const response = await PaymentSIROService.generatePaymentProcedure(body);

    if (response.success) {
      const redirectUrl = response.data?.Url;

      if (redirectUrl) {
        window.location.assign(redirectUrl);
        return { success: true, notCut: true };
      }
      return { success: false };
    }
  }
  
  static async handleProcedurePaymentMP(procedure) {
    const body = {
      procedureId: procedure.id,
      succes_url: ENV ?  `${FRONT_URL}/pago-resultado` : 'https://www.google.com.ar/',
      failure_url: ENV ?  `${FRONT_URL}/pago-resultado` : 'https://www.youtube.com/',
      pending_url: ENV ?  `${FRONT_URL}/pago-resultado` : 'https://www.facebook.com/',
    };

    const response = await PaymentMPService.generatePaymentProcedure(body);

    if (response.success) {
      const redirectUrl = response.data?.init_point;

      if (redirectUrl) {
        window.location.assign(redirectUrl);
        return { success: true, notCut: true };
      }
      return { success: false };
    }
  }
}

export default PaymentHandlers;
